import api from "./api";

export default {
  async listCourses() {
    const response = await api.get(`/api/courses/`);
    return response.data;
  },
  async getCourse(id) {
    const response = await api.get(`/api/courses/${id}/`);
    return response.data;
  },
  async listLessons() {
    const response = await api.get(`/api/lessons/`);
    return response.data;
  },
  async getLesson(id) {
    const response = await api.get(`/api/lessons/${id}/`);
    return response.data;
  }
};
